import isEmpty from 'validator/es/lib/isEmpty'
import isNumeric from 'validator/es/lib/isNumeric'
import isLatLong from 'validator/es/lib/isLatLong'
import isEmail from 'validator/lib/isEmail'

export const IsRequiredValidator = () => ({
  isRequired: (value) => !isEmpty(value, { ignore_whitespace: true }),
})

export const IsNumericValidator = () => ({
  isNumeric: (value) => isNumeric(value),
})

export const IsPositiveValidator = () => ({
  isPositive: (value) => value > 0,
})

export const IsEmailValidator = () => ({
  isEmail: (value) => isEmail(value),
})

const ValidatorGenerator = (type) => {
  if (type === 'noValidation') {
    return { noValidation: () => true }
  }
  if (type === 'isLatLng') return { isLatLng: (value) => isLatLong(value) }

  if (type === 'isRequired' || type === 'required') {
    return {
      ...IsRequiredValidator(),
    }
  }
  if (type === 'isNumeric') {
    return {
      ...IsRequiredValidator(),
      ...IsNumericValidator(),
    }
  }
  if (type === 'isPositive') {
    return {
      ...IsRequiredValidator(),
      ...IsNumericValidator(),
      ...IsPositiveValidator(),
    }
  }
  if (type === 'isEmail') {
    return {
      ...IsRequiredValidator(),
      ...IsEmailValidator(),
    }
  }
  throw Object.assign(new Error('In correct Type'), { code: 404 })
}

export default ValidatorGenerator
